import { AppointmentData, TimeSlot } from "@/data/interfaces/Appointments";
import { MednetCity } from "@/data/mednetLocations";
import api from "./api";

async function fetchAppointmentData(
  visitRegId: number,
  options?: { city?: MednetCity },
): Promise<AppointmentData> {
  const resp = await api.get(`/appointments/${visitRegId}`, {
    params: options?.city ? { city: options.city } : undefined,
  });
  return resp.data.data as AppointmentData;
}

async function getAvailableSlots(
  visitRegId: number,
  payload: { location: number; service: number; worker: number; date: string },
): Promise<TimeSlot[]> {
  const resp = await api.post(`/appointments/slots/${visitRegId}`, payload);
  return resp.data as TimeSlot[];
}

type RegistrationPayload = {
  location: number;
  location_name: string;
  service: number;
  service_name: string;
  worker: number;
  worker_name: string;
  date: string; // YYYY-MM-DD
  start: string; // HH:MM:SS
};

export default {
  fetchAppointmentData,
  getAvailableSlots,
  registerAppointment: async (
    visitRegId: number,
    payload: RegistrationPayload,
  ) => {
    const resp = await api.post(
      `/appointments/register/${visitRegId}`,
      payload,
    );
    return resp.data;
  },
};
